import { AxiosResponse } from 'axios';
import { ListSession, Session } from '../types/session';
import { api } from './api';

async function requestDeleteSession(
  sessionIdList: string[],
  authenticateOnAPI: () => Promise<string>,
  isBetaUser: boolean,
): Promise<AxiosResponse | null> {
  if (sessionIdList.length === 0) return null;

  try {
    const token = await authenticateOnAPI();
    const url = isBetaUser ? '/user-session' : '/session';

    return await api.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        GLBID: document.cookie.replace(
          /(?:(?:^|.*;\s*)GLBID\s*=\s*([^;]*).*$)|^.*$/,
          '$1',
        ),
      },
      data: { sessionIdList },
    });
  } catch {
    throw new Error('Não foi possível deletar a sessão do usuário.');
  }
}

function extractSessionIds(sessions: Session[]): string[] {
  return sessions
    .filter(session => !session.isActive)
    .flatMap(session => session.sessionIds || [session.sessionId])
    .filter(Boolean) as string[];
}

export async function deleteSession(
  session: Session,
  authenticateOnAPI: () => Promise<string>,
  isBetaUser: boolean,
): Promise<string[] | null> {
  const sessionIds = extractSessionIds([session]);
  const response = await requestDeleteSession(
    sessionIds,
    authenticateOnAPI,
    isBetaUser,
  );

  return response?.status === 200 ? sessionIds : null;
}

export async function deleteWithSessionData(
  sessionData: ListSession[],
  authenticateOnAPI: () => Promise<string>,
  isBetaUser: boolean,
): Promise<ListSession[] | null> {
  const sessionIdList = extractSessionIds(sessionData.flatMap(s => s.sessions));
  const response = await requestDeleteSession(
    sessionIdList,
    authenticateOnAPI,
    isBetaUser,
  );

  if (response?.status !== 200) return null;

  return sessionData
    .map(({ sessions, ...itemInfoSession }) => ({
      ...itemInfoSession,
      sessions: sessions.filter(session => session.isActive),
    }))
    .filter(item => item.sessions.length > 0);
}
